import dayjs from 'shared/dayjs'
import _ from 'lodash'

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export const difference = (object, base) => {
  const changes = (o, b) => {
    return _.transform(o, function (result: any, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] =
          _.isObject(value) && _.isObject(base[key])
            ? changes(value, b[key])
            : value
      }
    })
  }
  return changes(object, base)
}

export const getAttemptString = (
  attempt: null | number | undefined,
  maxAttempts: number | undefined,
  allowRetry: boolean,
  customInfinityText?: string
) => {
  if (!attempt) {
    return ''
  }
  if (!allowRetry) {
    return `${attempt}/1`
  }
  return `${attempt}/${
    maxAttempts === 0 ? customInfinityText || '∞' : maxAttempts
  }`
}

export const getScoreString = (
  autoCorrect: null | undefined | number,
  availablePoints: null | undefined | number
) => {
  if (
    typeof autoCorrect !== 'number' ||
    typeof availablePoints !== 'number' ||
    (autoCorrect === 0 && availablePoints === 0)
  ) {
    return null
  }

  // sometimes SCORM does not have available points and return autoCorrect > 0 in percentages
  if (autoCorrect > availablePoints) {
    return `${autoCorrect}%`
  }

  return `${parseFloat(((autoCorrect / availablePoints) * 100).toFixed(1))}%`
}

export const formatTimeInSec = (
  timeInSec: number | undefined | null,
  format: string = 'm[m] s[s]'
) => {
  if (!timeInSec) {
    return null
  }
  return dayjs.duration(timeInSec, 'seconds').format(format)
}

export const getPagesCount = (
  itemsCount: number | undefined,
  itemsPerPage: number
): number => {
  return Math.ceil((itemsCount ?? 0) / itemsPerPage)
}

export const normalizeFilterFormat = (selectedFilterValues, filteredBy) => {
  if (
    filteredBy.hasOwnProperty('from') &&
    !(selectedFilterValues.from instanceof dayjs)
  ) {
    selectedFilterValues.from = dayjs(selectedFilterValues.from)
  }

  if (
    filteredBy.hasOwnProperty('to') &&
    !(selectedFilterValues.to instanceof dayjs)
  ) {
    selectedFilterValues.to = dayjs(selectedFilterValues.to)
  }

  if (filteredBy.hasOwnProperty('selectedDateRange')) {
    selectedFilterValues.selectedDateRange = parseInt(
      selectedFilterValues.selectedDateRange,
      10
    )
  }

  if (filteredBy.hasOwnProperty('workspaceIds')) {
    if (!(selectedFilterValues.workspaceIds instanceof Array)) {
      selectedFilterValues.workspaceIds = [
        parseInt(selectedFilterValues.workspaceIds, 10)
      ]
    }
  }

  if (filteredBy.hasOwnProperty('pathwayIds')) {
    if (!(selectedFilterValues.pathwayIds instanceof Array)) {
      selectedFilterValues.pathwayIds = [
        parseInt(selectedFilterValues.pathwayIds, 10)
      ]
    }
  }

  if (filteredBy.hasOwnProperty('groupIds')) {
    if (!(selectedFilterValues.groupIds instanceof Array)) {
      selectedFilterValues.groupIds = [
        parseInt(selectedFilterValues.groupIds, 10)
      ]
    }
  }

  if (filteredBy.hasOwnProperty('includeAdmins')) {
    selectedFilterValues.includeAdmins =
      selectedFilterValues.includeAdmins === 'true'
  }

  if (filteredBy.hasOwnProperty('includeArchived')) {
    selectedFilterValues.includeArchived =
      selectedFilterValues.includeArchived === 'true'
  }

  if (filteredBy.hasOwnProperty('includeDrafts')) {
    selectedFilterValues.includeDrafts =
      selectedFilterValues.includeDrafts === 'true'
  }

  return selectedFilterValues
}
